import React, { useState, useEffect, useRef } from 'react';
import useDeeplink from '@hooks/use-deeplink';
import styles from './index.module.scss';

const BlackList = ['/cms/'];

export function Share() {
  const [wla] = useDeeplink();

  const [position, setPosition] = useState({ y: 500 });
  const dragRef = useRef(null);
  const isDragging = useRef(false);
  const startPos = useRef({ y: 0 });

  const handleClick = () => {
    if (isDragging.current) return;
    wla?.open();
  };

  useEffect(() => {
    const handleTouchStart = e => {
      isDragging.current = false;
      const touch = e.touches[0];
      startPos.current = {
        y: touch.clientY - position.y
      };
    };

    const handleTouchMove = e => {
      isDragging.current = true;
      const touch = e.touches[0];
      const newY = Math.min(
        Math.max(50, touch.clientY - startPos.current.y),
        window.innerHeight - 100
      );
      setPosition({ y: newY });
    };

    const handleTouchEnd = () => {
      setTimeout(() => {
        isDragging.current = false;
      }, 100);
    };

    const element = dragRef.current;
    if (element) {
      element.addEventListener('touchstart', handleTouchStart);
      element.addEventListener('touchmove', handleTouchMove);
      element.addEventListener('touchend', handleTouchEnd);
    }

    return () => {
      if (element) {
        element.removeEventListener('touchstart', handleTouchStart);
        element.removeEventListener('touchmove', handleTouchMove);
        element.removeEventListener('touchend', handleTouchEnd);
      }
    };
  }, [position]);

  if (BlackList.some(item => location.pathname.indexOf(item) >= 0)) return null;

  return (
    <div
      ref={dragRef}
      className={styles.share}
      onClick={handleClick}
      style={{
        transform: `translateY(${position.y}px)`
      }}
    >
      App 内打开
    </div>
  );
}
